import { EditorState, Transaction } from "prosemirror-state";
import { isLocal } from "../utils/environment";

const transactionToStack = new WeakMap<Transaction, Error>();

export function getTransactionOrigin(tr: Transaction) {
  return transactionToStack.get(tr);
}

if (isLocal) {
  const oldProto = EditorState.prototype;
  const desc = Object.getOwnPropertyDescriptor(oldProto, "tr");

  Object.defineProperty(EditorState.prototype, "tr", {
    get: function (...args) {
      const newTransaction = desc?.get?.call(this, ...args);
      transactionToStack.set(newTransaction, new Error());
      return newTransaction;
    },
  });
}
